import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
// import { CreateVoucherApi } from "../../Utils/Api/CreateVoucherApi";
import Loader from "../Loader/Loader";
// import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";

const Modals = ({ saveButtonfuc,loading, ...props }) => {
  // const [loading, setLoading] = useState(false);

  const dataApi = props.saveButton;
  const navigate = useNavigate();

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="Modal">
        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="modalMain create-vou-modal"
        >
          {/* <Modal.Header closeButton></Modal.Header> */}

          <Modal.Body>
            <div className="d-flex flex-column align-items-center">
              <img loading="lazy" src={props.images} />
              <p style={{ paddingTop: "20px" }}>{props.description}</p>
              <div className="modal-buttons">
                <button onClick={props.onHide}>{props.firstbutton}</button>
                <button
                  onClick={() => {
                    saveButtonfuc();
                  }}
                >
                  {props.secondbutton}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default Modals;
